export * from './post-feld.component';
export * from './post-feld.component.module';